const styles = {
  container: {
    padding: '30px',
    minHeight: '100vh',
    backgroundColor: '#f4f6f9'
  },
  header: {
    color: '#1B019B',
    fontWeight: '600',
    fontSize: '1.5rem',
    textAlign: 'center',
    marginBottom: '10px'
  },
  hr: {
    width: '80px',
    border: '2px solid #1B019B',
    opacity: '1',
    margin: '10px auto 20px'
  },
  organisationHeader: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  navButton: {
    backgroundColor: '#1B019B',
    color: 'white',
    borderRadius: '8px 0 0 8px',
    border: '1px solid #1B019B',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
  },
  secondaryNavButton: {
    backgroundColor: '#fff',
    color: '#1B019B',
    borderRadius: '0 8px 8px 0',
  },
  statsCard: {
    padding: '20px',
    borderRadius: '12px',
    background: 'white',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    textAlign: 'center'
  },
  statsCardPrimary: {
    padding: '20px',
    borderRadius: '12px',
    background: '#d4edda',
    color: '#155724',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    textAlign: 'center'
  },
  filterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    gap: '20px',
    flexWrap: 'wrap'
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  filterLabel: {
    fontWeight: '600',
    color: '#1B019B',
    marginBottom: 0
  },
  searchBar: {
    flexGrow: 1,
    maxWidth: '400px',
    height: '38px',
    borderRadius: '20px',
    paddingLeft: '15px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    minWidth: '180px'
  },
  select: {
    width: '180px',
    height: '38px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    padding: '0 10px'
  },
  exportButton: {
    backgroundColor: '#1B019B',
    color: 'white',
    borderRadius: '30px',
    padding: '8px 20px',
    border: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    height: '38px',
    cursor: 'pointer',
    minWidth: '150px',
    justifyContent: 'center'
  },
  exportButtonDisabled: {
    backgroundColor: '#ccc',
    color: '#666',
    borderRadius: '30px',
    padding: '8px 20px',
    border: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    height: '38px',
    cursor: 'not-allowed',
    minWidth: '150px',
    justifyContent: 'center'
  },
  tableCard: {
    borderRadius: '15px',
    border: 'none'
  },
  tableHeader: {
    backgroundColor: '#1B019B',
    color: 'white'
  },
  paginationButton: {
    backgroundColor: '#1B019B',
    color: 'white',
    border: 'none',
    padding: '8px 12px',
    cursor: 'pointer'
  },
  paginationActive: {
    backgroundColor: '#0d0066'
  },
  paginationDisabled: {
    backgroundColor: '#e0e0e0',
    color: '#a0a0a0',
    cursor: 'not-allowed',
    border: 'none',
    padding: '8px 12px'
  }
};

export default styles;